(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"] && !Shopify.designMode) return;
  try {
    
/* Stable HTML fallback; related posts are progressively randomized per page view. */
(() => {
  if (window.__dreamCipherArticleV2Loaded) return;
  window.__dreamCipherArticleV2Loaded = true;
  const shuffleRelated = root => {
    const section = root.querySelector('[data-dc-related]');
    if (!section || section.dataset.ready) return;
    const list = section.querySelector('[data-dc-related-list]');
    const pool = section.querySelector('[data-dc-related-pool]');
    if (!list || !pool) return;
    const seen = new Set();
    const cards = [...list.children, ...pool.content.children].filter(card => {
      const id = card.dataset.relatedId;
      if (!id || seen.has(id)) return false;
      seen.add(id); return true;
    });
    const count = Math.min(Math.max(Number(section.dataset.count) || 3, 1), cards.length);
    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cards[i], cards[j]] = [cards[j], cards[i]];
    }
    const fragment = document.createDocumentFragment();
    cards.slice(0, count).forEach(card => fragment.appendChild(card));
    list.replaceChildren(fragment);
    pool.remove();
    section.dataset.ready = 'true';
  };
  const buildToc = root => {
    const body = root.querySelector('[data-dc-body]');
    const toc = root.querySelector('[data-dc-toc]');
    if (!body || !toc) return;
    if (body.querySelector('.dc-toc, [data-table-of-contents], nav[aria-label="In this article"], nav[aria-label="Article contents"]')) return;
    const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
    if (headings.length < 3) return;
    const list = toc.querySelector('[data-dc-toc-list]');
    if (!list) return;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = `${root.id}-heading-${index + 1}`;
        let id = base, suffix = 1;
        while (document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + encodeURIComponent(heading.id);
      a.textContent = heading.textContent.trim();
      li.appendChild(a); list.appendChild(li);
    });
    toc.hidden = false;
  };
  const init = scope => {
    const roots = scope.matches?.('[data-dc-article]') ? [scope] : scope.querySelectorAll('[data-dc-article]');
    roots.forEach(root => {
      if (root.dataset.dcV2Ready) return;
      root.dataset.dcV2Ready = 'true';
      // Related posts must initialize even when the body already contains a TOC.
      shuffleRelated(root);
      buildToc(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
